import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Footer from './footer';
import $ from 'jquery';
import IntroduceMultiSign from "./introduce-multisign";
import IntroduceCoin from "./introduce-coin";
import Section1 from "./section1";
import Section2 from "./section2";
import Section3 from "./section3";
import Section5 from "./section5";
import Section6 from "./section6";
import Section7 from "./section7";
import Section8 from "./section8";
import Section10 from "./section10";

class Home extends Component {
    constructor (props) {
        super(props);
        this.state = {
            home: 'home_57'
        }
    }

    componentDidMount () {
        const query = new URLSearchParams(document.location.search);
        const lang = query.get('lang');
        if(lang && ['en', 'ch', 'ja', 'ko'].includes(lang)) {
            localStorage.setItem('i18nextLng', lang);
        }
        setTimeout(() => this.node.scrollIntoView(), 0);
        if (localStorage.getItem('i18nextLng') === 'vi-VN') {
            localStorage.setItem('i18nextLng', 'en');
        }
        $('#quickly-event').click(function(){
            $('html, body').animate({
                'scrollTop':   $('#quickly').offset().top -70
            }, 1800);
        });
        $('#secure-event').click(function(){
            $('html, body').animate({
                'scrollTop':   $('#secure').offset().top -30
            }, 1800);
        });

        $('#low-fee-event').click(function(){
            $('html, body').animate({
                'scrollTop':   $('#low-fee').offset().top -100
            }, 2000);
        });
    }

    render() {
        return (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <div id="wrapper" ref={node => this.node = node}>
                            <Section1 />
                            <Section2 />
                            <Section3 />
                            <IntroduceMultiSign/>
                            <Section5 />
                            <Section6 />
                            <Section7 />
                            <Section8 />
                            {/*<Section9 />*/}
                            <Section10 />
                            <IntroduceCoin/>
                            <Footer/>
                        </div>
                    )
                }
            </I18n>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/home.jsx